import { motion } from "motion/react";
import { Col, Container, Row } from 'react-bootstrap';
import brandData from '../../data/brandData.json';

const Process = () => {
  const stepVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (index) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: index * 0.15 }
    })
  }

  const progressVariants = {
    hidden: { scaleX: 0 },
    visible: {
      scaleX: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  }

  return (
    <section className='section-lg overflow-hidden' id='brand-process'>
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 className="underline-after position-relative text-center z-0"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              <span className="position-relative z-1 bg-white text-primary px-3">Process</span>
            </motion.h6>
            <motion.h1 className="d-block text-gradiant text-center fw-semibold"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              From insights to brand system
            </motion.h1>
          </Col>
        </Row>
        <div className="d-none d-md-flex align-items-center">
          {brandData.process.map((step, index) => (
            <div key={step.id} className="d-flex align-items-center" style={{ flex: index < brandData.process.length - 1 ? 1 : 'initial' }}>
              <motion.div className="text-center" 
                style={{ minWidth: '180px' }}
                variants={stepVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={index}
                whileHover={{ y: -8, transition: { duration: 0.3 } }}
              >
                <motion.div className="d-inline-flex align-items-center justify-content-center rounded-circle border border-primary text-primary mb-2"
                  style={{ width: '56px', height: '56px' }}
                  whileHover={{ rotate: 360, scale: 1.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <strong>{step.number}</strong>
                </motion.div>
                <h6 className="mb-1">{step.title}</h6>
                <small className="text-secondary">{step.description}</small>
              </motion.div>
              {index < brandData.process.length - 1 && (
                <div className="flex-grow-1 px-3">
                  <div className="progress" style={{ height: '4px' }}>
                    <motion.div className="progress-bar bg-success" 
                      style={{ width: '100%', transformOrigin: 'left' }}
                      variants={progressVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                    ></motion.div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default Process;
